'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getLoc = require('./getLoc');

var _getLoc2 = _interopRequireDefault(_getLoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copy location information from the source node to the newly created node.
exports.default = function placeAtNode(newNode, sourceNode) {
  return Object.assign(newNode, (0, _getLoc2.default)(sourceNode));
};


//////////////////
// WEBPACK FOOTER
// ../~/ast-loc-utils/lib/placeAtNode.js
// module id = 990
// module chunks = 0